import React from 'react';
import type { ActivityLogEntry } from '../warehouseDashboardTypes';
import styles from './ActivityLog.module.css';

interface ActivityLogProps {
  entries: ActivityLogEntry[];
}

export const ActivityLog: React.FC<ActivityLogProps> = ({ entries }) => {
  return (
    <div className={styles.card}>
      <h3 className={styles.heading}>Recent Activity Log</h3>
      <div className={styles.timeline}>
        {entries.map((entry) => (
          <div key={entry.id} className={styles.entry}>
            <div className={`${styles.dot} ${styles[entry.color]}`} />
            <div className={styles.entryContent}>
              <p className={styles.entryTitle}>{entry.title}</p>
              <p className={styles.entryDescription}>{entry.description}</p>
              <p className={styles.entryMeta}>
                {entry.timeAgo} &middot; {entry.author}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
